import styled from 'styled-components';
import { COLORS, DEVICES, FONT_FAMILY } from '@Commons';

export const IdentityPageContainer = styled.div`
  margin-top: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .navigationContainer {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    align-items: center;
    justify-content: center;
    z-index: 2;

    .backButton {
      grid-column: 1;
      cursor: pointer;
    }
    * {
      justify-self: center;
    }
    @media ${DEVICES.mobileXL} {
      margin-top: 48px;

      .backButton {
        justify-self: start;
      }
    }
  }

  .mainContainer {
    max-width: 450px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-top: -38px;

    .image {
      width: 64px;
      height: 64px;
    }
    .heading {
      font-family: ${FONT_FAMILY.hellix.bold};
      font-size: 28px;
      line-height: 38px;
      color: ${COLORS.black};
      margin-top: 16px;
    }

    .description {
      font-family: ${FONT_FAMILY.hellix.regular};
      font-size: 16px;
      line-height: 22px;
      color: ${COLORS.textGrey};
      margin-top: 8px;
    }

    .docRequiredContainer {
      margin-top: 48px;
      border: 1px solid rgba(72, 250, 255, 0.4);
      background: rgba(72, 250, 255, 0.1);
      display: flex;
      width: 100%;
      padding: 15px;
      gap: 12px;
      .column1 {
        flex: 0 0 5%;
      }

      .column2 {
        flex: 1;
        text-align: left;
        font-family: ${FONT_FAMILY.hellix.regular};
        font-size: 14px;
        line-height: 18px;

        ul {
          list-style-type: disc;
          margin-left: 20px;

          li {
            margin-top: 3px;
          }
        }
      }
    }

    .btnWrapper {
      margin-top: 48px;
      display: flex;
      justify-content: center;
      width: 100%;

      button {
        width: 100%;
        @media ${DEVICES.mobileXL} {
          width: 80vw;
        }
      }
    }

    @media ${DEVICES.mobileXL} {
      max-width: 80vw;
    }
  }
`;

export const CenterContainer = styled.div`
  min-height: 70vh;
  padding: 0 16px;
  align-items: center;
  justify-content: center;

  display: flex;

  .innerContainer {
    max-width: 450px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    .heading {
      font-family: ${FONT_FAMILY.hellix.bold};
      font-size: 28px;
      line-height: 38px;
      color: ${COLORS.black};
      margin-top: 32px;
    }

    .description {
      font-family: ${FONT_FAMILY.hellix.regular};
      font-size: 16px;
      line-height: 22px;
      color: ${COLORS.textGrey};
      margin-top: 16px;
    }
    .sendMoneyBtnWrapper {
      display: flex;
      width: 100%;
      margin-top: 48px;
      justify-content: center;
    }
    .btnWrapper {
      margin-top: 48px;
    }
  }
`;

export const Title = styled.div`
  align-self: center;
  text-align: center;
  font-size: 20px;
  margin-bottom: 20px;
  color: ${COLORS.newBrandBlue};
  font-family: ${FONT_FAMILY.hellix.bold};
`;

export const Content = styled.div`
  align-self: center;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin: 5px 0 10px 0;
  color: ${COLORS.newBrandBlue};
  text-align: center;
  font-size: 14px;
  font-family: ${FONT_FAMILY.hellix.regular};
`;

export const IframeContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 80%;

  iframe {
    height: 700px;
    width: 90%;
  }
`;

export const LoaderImage = styled.img`
  width: 100px !important;
  height: 100px !important;
`;

export const LoadingContainerDetails = styled.div`
  .heading {
    color: ${COLORS.black};
    text-align: center;
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 28px;
    font-style: normal;
    line-height: 38px;
    margin: -30px 0px 8px 0px;
  }

  .description {
    color: ${COLORS.textGrey};
    text-align: center;
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 16px;
    font-style: normal;
    line-height: 22px;
  }
`;
